module.exports = JSON.parse('{"Series is tracked":"Test Series is tracked","Series is untracked":"Test Series is untracked","Viewport":"Test Viewport"}')